import gamePreviewIcon from '../../assets/icons/preview-icon.svg';
import optionsYellowIcon from '../../assets/icons/options-yellow-icon.svg';
import defaultGameIcon1 from '../../assets/icons/default-game-icon-1.svg';
import { ISentForApprovalPanel } from '../../interfaces/panel';
import './index.scss';
import { useEffect, useState } from 'react';
import { IAPIResponse } from '../../interfaces/api';
import { IGameInfo, IndexedGameInfo } from '../../interfaces/game-info';
import { getSentForApprovalList } from '../../api/makerChecker';
import { addSentForApprovalGames } from '../../slices/maker-checker';
import { LoadingIndicator } from '../Loading';
import { NoDataAvailable } from '../NoDataAvailable';
import { useAppDispatcher, useAppSelector } from '../../hooks/redux';
import { NewGamePopup } from '../Popup';
import { useRefreshEventSubscriber } from '../../hooks/rxjs';
import { AnimatePresence } from 'framer-motion';
import { checkAPIResponse } from '../../utils/utils';
import { log } from '../../utils/logger';

export const SentForApprovalPanel = (props: ISentForApprovalPanel) => {
    const dispatcher = useAppDispatcher();
    const lanid: string = useAppSelector((state) => state.userInfo.lanid);
    const sentForApprovalGameInfo: IndexedGameInfo = useAppSelector((state) => state.makerCheckerGames.info);
    const [isSentForApprovalGamesListLoading, setSentForApprovalGamesListLoadingStatus] = useState<boolean>(false);
    const [checkerPopupVisibility, setCheckerPopupVisibility] = useState<{ visibility: boolean, gameDetails: IGameInfo | null }>({ visibility: false, gameDetails: null });

    const generateFormattedDate = (dateString: string | null | undefined): string => {
        if (dateString != null) {
            const date: Date = new Date(dateString);
            return date.toLocaleString();
        }
        else {
            return '';
        }
    }

    const getSentForApprovalGames = async (): Promise<void> => {
        setSentForApprovalGamesListLoadingStatus(true);
        const sentForApprovalList: IAPIResponse<Array<IGameInfo>> = await getSentForApprovalList<IGameInfo>(lanid);
        const formattedResponse = checkAPIResponse<Array<IGameInfo>>(sentForApprovalList);

        if (formattedResponse.status === true && sentForApprovalList.response != null && sentForApprovalList.response.data != null) {
            dispatcher(addSentForApprovalGames(sentForApprovalList.response.data));
        }
        else {
            if (formattedResponse.message != null) {
                log.Error(`Unable to load sent for approval games (${formattedResponse.message})`);
            }
            else {
                log.Error(`Unable to load sent for approval games`);
            }
        }

        setSentForApprovalGamesListLoadingStatus(false);
    }

    useEffect(() => {
        getSentForApprovalGames();
    }, []);

    useRefreshEventSubscriber('approval', getSentForApprovalGames);

    return <div className='approval-wrapper'>
        <div className='approval-header-container'>
            <div className='approval-header-wrapper'>
                <img src={gamePreviewIcon} alt='' />
                <span>Sent for Approval</span>
            </div>
            <div className='approval-header-options-container'>
                {/* <img src={optionsYellowIcon} alt='' /> */}
            </div>
        </div>
        <div className='approval-body-container'>
            {isSentForApprovalGamesListLoading === true ? <LoadingIndicator /> : (Object.values(sentForApprovalGameInfo).length > 0 ?
                <>
                    {Object.values(sentForApprovalGameInfo).map((obj: IGameInfo, index: number) => (
                        <div className='game-info-container' key={`sent-for-approval-container-${index}`}>
                            <div className='game-info-image-container'>
                                <img src={defaultGameIcon1} alt='' />
                            </div>
                            <div className='game-info-details-container'>
                                <span className='game-name-text'>{obj.gameName}</span>
                                <span className='game-status-text'>{`Type: ${obj.status}`}</span>
                                <span className='game-description-text'>{generateFormattedDate(obj.lastChangedOn)}</span>
                            </div>
                            <div className='game-info-miscellaneous-container'>
                                <div className='game-info-button-container'>
                                    <span onClick={() => setCheckerPopupVisibility({ visibility: true, gameDetails: obj })}>View</span>
                                </div>
                                <div className='game-status-container'>
                                    <span className='pending'>Pending</span>
                                </div>
                            </div>
                        </div>
                    ))
                    }
                </>
                : <NoDataAvailable />)}
        </div>
        <AnimatePresence>
            {checkerPopupVisibility.visibility === true &&
                <NewGamePopup
                    isApprovalMode={true}
                    updationGameInfo={checkerPopupVisibility.gameDetails}
                    closePopup={() => setCheckerPopupVisibility({ visibility: false, gameDetails: null })}
                />
            }
        </AnimatePresence>
    </div>
}